<style scoped lang="scss" type="text/scss">
    /*必须写在最外层*/
    .search-box {
        width: 100%;
    }
</style>

<template>
    <el-select
            class="search-box"
            v-model="valueSync"
            filterable
            remote
            clearable
            :disabled="disabled"
            :placeholder="placeholder"
            :remote-method="remoteMethod"
            :loading="loading">
        <el-option
                v-for="item in candidates"
                :key="item.id"
                :label="item.name"
                :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: '',
        props: {
            value: String | Number,
            placeholder: {
                type: String,
                default: '输入校名进行搜索'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                valueSync: null,
                loading: false,
                candidates: []
            };
        },
        watch: {
            value (value) {
                this.valueSync = value;
                if (value !== null && value !== undefined) {
                    this.$store.dispatch('school/loadSchoolInfo', {
                        id: value
                    }).then(response => {
                        this.candidates = [response.data];
                    });
                } else {
                    this.candidates = [];
                    this.valueSync = null;
                }
            },
            valueSync (valueSync) {
                if (valueSync === '') {
                    this.valueSync = null;
                    return;
                }
                this.$emit('input', valueSync);
            }
        },
        methods: {
            remoteMethod (query) {
                if (query !== '') {
                    this.loading = true;
                    this.$normalRequest('school/searchByFuzzyName', {name: query}).then(data => {
                        this.loading = false;
                        this.candidates = data;
                    }).catch(_ => {
                        this.loading = false;
                        this.candidates = [];
                    });
                } else {
                    this.candidates = [];
                }
            }
        }
    };
</script>
